import {NodeType} from "../components/CategoryTree";

const ALL_NOTES: NodeType = {type: 'all_notes', id: -1, name: 'ALL NOTES'} as const;
const ROOT_LEVEL: NodeType = {type: 'root_level', id: 0, name: 'UNASSIGNED'} as const;

export {ALL_NOTES, ROOT_LEVEL}